export enum PopupViewType {
  DISCOUNT_DETAIL = 'DISCOUNT_DETAIL',
  MILEAGE = 'MILEAGE',
  SHIPPING = 'SHIPPING',
  INTEREST_FREE = 'INTEREST_FREE',
  MAXIMUM_BENEFIT = 'MAXIMUM_BENEFIT',
  BEAUTY_INGREDIENT_INFO = 'BEAUTY_INGREDIENT_INFO',
  BEAUTY_INGREDIENT_NOTICE = 'BEAUTY_INGREDIENT_NOTICE',
  SIZE_INFO = 'SIZE_INFO',
  PAYMENT_EVENT_INFO = 'PAYMENT_EVENT_INFO',
  MILEAGE_HELP_TEXT = 'MILEAGE_HELP_TEXT',
  SIZE_INFO_AGREEMENT = 'SIZE_INFO_AGREEMENT',
  MY_PURCHASE_LIST = 'MY_PURCHASE_LIST',
  SIZE_INFO_AGREEMENT_DETAIL = 'SIZE_INFO_AGREEMENT_DETAIL',
}
